import * as React from 'react';

import {useGetLandingPages, useGetLandingPageStarters} from '../graphql/hooks';

import {categorizeLandingPageStarters} from './helpers';
import {NamePageModal} from './name-page-modal';
import {StartFromPageSelectionModal} from './start-from-page-selection-modal';

export const START_FROM_SCRATCH_ID = 'start-from-scratch';

export type SelectedStarter = {
    id: string;
    name?: string | null | undefined;
};

type Props = {
    onClose: () => void;
};

export function CreatePageModalRoot(props: Props) {
    const [selectedStarter, setSelectedStarter] = React.useState<SelectedStarter>({
        id: START_FROM_SCRATCH_ID,
    });
    const [isNamingPage, setIsNamingPage] = React.useState<boolean>(false);

    const {
        landingPages: recentPages,
        isLoading: isLoadingRecent,
        error: recentPagesError,
    } = useGetLandingPages();
    const {pageStarters: templatePages, isLoading: isLoadingTemplates} =
        useGetLandingPageStarters();

    const starterOptions = [];
    if (recentPages) {
        starterOptions.push({
            id: 'recent-pages',
            title: 'Recent page',
            subtitle: 'Your recent pages',
            error: recentPagesError,
            collection: [
                {
                    id: START_FROM_SCRATCH_ID,
                    createNew: {height: recentPages.length === 0 ? 300 : undefined},
                },
                ...recentPages.map((page) => ({
                    id: page.id,
                    existingPage: {
                        name: page.name,
                        customPublishedUrl: page.customPublishedUrl,
                        nutshellPublishedUrl: page.nutshellPublishedUrl,
                        lastModifiedTime: page.lastModifiedTime,
                        thumbnailUrl: page.thumbnailUrl,
                        backgroundColor: page.backgroundColor,
                    },
                })),
            ],
        });
    }

    if (templatePages) {
        starterOptions.push(...categorizeLandingPageStarters(templatePages));
    }

    return isNamingPage ? (
        <NamePageModal
            onClickBack={() => {
                setIsNamingPage(false);
            }}
            selectedStarterId={selectedStarter.id}
            name={selectedStarter.name && `Copy of ${selectedStarter.name}`}
        />
    ) : (
        <StartFromPageSelectionModal
            onClose={props.onClose}
            onClickNext={() => {
                setIsNamingPage(true);
            }}
            starterOptions={starterOptions}
            selectedStarter={selectedStarter}
            setSelectedStarter={setSelectedStarter}
            isLoading={isLoadingRecent || isLoadingTemplates}
        />
    );
}
